import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { queryUserDepositAccount } from '@/features/portal/deposit-accounts/api/user-deposit-accounts';
import { UserDepositAccount } from '@/features/portal/deposit-accounts/account/UserDepositAccount.tsx';
import NotFoundDepositAccount from '@/components/ui/deposit-accounts/NotFoundDepositAccount.tsx';

export const Route = createFileRoute(
  '/portal/deposit-account/$depositAccountId',
)({
  loader: ({ params }) =>
    crownQueryClient.ensureQueryData(
      queryUserDepositAccount(params.depositAccountId),
    ),
  head: ({ loaderData }) => ({
    meta: [{ title: loaderData ? loaderData.nickname : 'Account' }],
  }),
  component: UserDepositAccount,
  errorComponent: NotFoundDepositAccount
});
